<template>
  <div class="fullwidth ptop">
    <div class="zoom-flex">
      <div style="flex-grow:1">
        <div v-if="!image.animation">
          <img :src="imgsrc" style="width:100%" :alt="image.alt">
        </div>
        <zoom-animation :image="image" :artist="artist" v-if="image.animation" autoplay />
      </div>
      <image-description-panel :artist="artist" :image="image" />
    </div>
  </div>
</template>

<script>
import ImageDescriptionPanel from '@/components/panels/ImageDescriptionPanel'
import ZoomAnimation from '@/components/panels/ZoomAnimation.vue'
import apix from '@/api.js'
// This is just to allowing sharing an image on social media and easily linking to it
export default {
  components: {
    ImageDescriptionPanel,
    ZoomAnimation
  },
  props: {
    imageid: String,
    name: String
  },
  data () {
    return {
      artist: {},
      image: { detail: {}}
    }
  },
  created () {
    if(this.imageid){
      this.loadData()
    }
  },
  computed:{
    imgsrc: function () {
      if(this.image && this.image.url) {
        return this.$k.getZoomImage(this.image.url)
      }
      return ''
    }
  },
  beforeDestroy () {
    this.$k.removeTwitterAndOgs()
  },
  methods: {
    // should change this so it pulls the image using the artist id and image id
    // needs a server-side update
    loadData: async function () {
      this.artist = await this.$store.dispatch('fetchArtist', this.name)
      const imid = Number(this.imageid)
      const res = await apix.post('collections/images', { image_id: Number(imid) })
      if(res.data.length > 0) {
        this.image = res.data[0]
        this.artist = await this.$store.dispatch('fetchArtistById', this.image.artist_id)
        let desc =  this.artist.formatted_name
        if(this.image.alt) {
          desc += ' - ' + this.image.alt
        }
        let src = this.imgsrc
        let video = false
        if(this.image.animation) {
          video = (!this.image.swf.endsWith('.gif'))
          src = this.getMetaUrl(this.image)
          
        }
        if(this.artist.animation && this.image.animation) {
          desc = 'AnimationX - ' + desc
        }
        else {
          desc = 'IllustrationX - ' + desc
        }
        this.$k.setTwitterMetas(desc, src, video,  window.location.href, this.artist.formatted_name)
      }
    },
    getMetaUrl(image) {
      if(image.video_url) {
        return image.video_url
      }
      let ext = image.swf.split('.').pop().toLowerCase()
      if((ext === 'mov')||(ext === 'flv')){
        return `${this.$k.imagebase}media/artist/${this.artist.portfolio_url}/${this.image.swf}.mp4`
      }
      return `${this.$k.imagebase}media/artist/${this.artist.portfolio_url}/${this.image.swf}`
    }
  },
  watch: {
    imageid: function () {
      if(this.imageid){
        this.loadData()
      }
    }
  }

}
</script>

<style scoped>


.zoom-flex{
  display:flex;
  justify-content:center;
  cursor:default;
  width:100%;
}

.text-area{
  margin-left:20px;
  max-width:600px;
  min-width:200px;
  width: 20vw;
  display:flex;
  flex-direction:column;
  justify-content: space-between;
}


.ptop{
  padding-top:40px;
}
</style>
